/**
 * Utilitaire pour formater les dates de manière cohérente
 * Évite les problèmes d'hydratation entre serveur et client
 */

export const formatDate = (dateString) => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);
    // Forcer l'usage du format français pour éviter les différences de locale
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch (error) {
    console.error("Erreur lors du formatage de la date:", error);
    return "";
  }
};

export const formatDateLong = (dateString) => {
  if (!dateString) return "";

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch (error) {
    console.error("Erreur lors du formatage de la date:", error);
    return "";
  }
};
